import { IOffer } from "@nju/data-access-portal-offers";

function filterOffersForZone(offers: IOffer[], zone: string) {
  const zoneOffers = offers.filter((offer) => {return offer.zone === zone});

  if (zoneOffers.length === 0) {
    return [];
  }

  const commonOffers = offers.filter((offer) => {return !offer.zone});

  return [...commonOffers, ...zoneOffers];
}

export function groupOffersByPromoZone(offers: {
  dataPackage: IOffer[];
  voicePackage: IOffer[];
}) {
  const zones = new Set<string>();

  [...offers.dataPackage, ...offers.voicePackage].forEach((offer) => {
    if (offer.zone) {
      zones.add(offer.zone);
    }
  });

  return [...zones]
    .map((zone) => {return {
      zone,
      dataPackage: filterOffersForZone(offers.dataPackage, zone),
      voicePackage: filterOffersForZone(offers.voicePackage, zone),
    }})
    .sort((a, b) => {
      const aHasVoice = a.voicePackage.length > 0;
      const bHasVoice = b.voicePackage.length > 0;

      return Number(bHasVoice) - Number(aHasVoice);
    });
}
